import * as React from 'react';
import {styled} from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Collapse from '@mui/material/Collapse';
import IconButton, {IconButtonProps} from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {CardMedia, Divider, Stack} from "@mui/material";
import {HashLink as Link} from 'react-router-hash-link';
import {Helmet} from "react-helmet";


// TODO theres got to be a faster way to do this:

import Addteam from "../../../assets/images/help/AddTeam.jpg";
import AppliedFilter from "../../../assets/images/help/AppliedFilter.jpg";
import CompleteSet from "../../../assets/images/help/CompleteSet.jpg";
import Content from "../../../assets/images/help/ContentNoThumb.jpg";
import Grid from "../../../assets/images/help/Grid.jpg";
import KeywordSearch from "../../../assets/images/help/keywordSearch.jpg";
import Metacart from "../../../assets/images/help/metaCart.jpg";
import RecordDetail from "../../../assets/images/help/RecordDetail.jpg";
import RequestScan from "../../../assets/images/help/RequestAScan.jpg";
import SearchFilter from "../../../assets/images/help/SearchFilter.jpg";
import Security from "../../../assets/images/help/Security.jpg";
import Share from "../../../assets/images/help/Share.jpg";
import Shopping from "../../../assets/images/help/ShoppingCart.jpg";
import UploadFile from "../../../assets/images/help/UploadFile.jpg";
import Search from "../../../assets/images/help/Search.jpg";



import styles from './HelpPage.module.scss';

interface ExpandMoreProps extends IconButtonProps {
    expand: boolean;
}

const ExpandMore = styled((props: ExpandMoreProps) => {
    const {expand, ...other} = props;
    return <IconButton {...other} />;
})(({theme, expand}) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
}));

export default function RecipeReviewCard() {
    const [expanded, setExpanded] = React.useState(false);

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    return (
        <div className={styles.HelpPage}>
            <Helmet>
                <meta charSet="utf-8"/>
                <title>Help Page</title>
            </Helmet>

            <div className="standard-margin">
                <h1> Help Page</h1>
                <hr></hr>


                <h5>On this page:  &nbsp;  &nbsp; <Link to="#a"> Archiving Documents</Link> | <Link to="#b"> Classified
                    Documents </Link> | <Link to="#c"> Request a Scan</Link> | <Link to="#d"> Search for
                    Files </Link> | <Link to="#e"> Share Materials</Link> | <Link
                    to="#g"> Teams Chat</Link> | <Link to="#h"> View & Download Documents</Link></h5>


                {/*Archiving*/}
                <Card>
                    <CardContent className={styles.card}>

                        <div className={styles.margins}>

                            <h2 id="a"> Archiving Documents</h2>
                            <hr></hr>
                            <Stack
                                direction="row"
                                spacing={2}
                            >
                                <div>
                                    <p>
                                        We now provide a convenient method for uploading files for processing if you
                                        possess
                                        documentation
                                        and wish to utilize TIC (Technical Information Center) for archiving purposes.
                                    </p>
                                    <ul>
                                    <li className={styles.a}> Follow the guidelines on how to prepare and upload your
                                        file(s). -Note: If you have a high volume of uploads — please contact tic staff,
                                        prior to uploading.
                                    </li>

                                    <li className={styles.a}>See  <Link to={"./../workingwithtic"}>Working with TIC </Link>  for information on how to ship hard
                                        copies
                                        of your documents.
                                    </li>
                                    </ul>
                                </div>

                                <div className={styles.card}>
                                    <img src={UploadFile} alt="team" className={styles.image}/>
                                </div>
                            </Stack>
                        </div>
                    </CardContent>

                </Card>

                <br></br>

                {/*classified*/}

                <Card>
                    <CardContent className={styles.card}>

                        <div className={styles.margins}>

                            <h2 id="b">Classified Documents</h2>
                            <hr></hr>
                            <Stack
                                direction="row"
                                spacing={2}
                            >
                                <div>
                                    <p>
                                        You can find definitions and guidelines in the <Link to={"./../securityguidelines"}>Security Guidelines </Link>  page. To
                                        request access to documents with classifications other than public (PUB) or
                                        restricted (RES), you will need the relevant form and supervisor's
                                        authorization.
                                    </p>
                                    <ul>
                                    <li className={styles.a}> Please note that for restricted documents, you must save
                                        the form(s) using the 'save icon' or 'save as' option in the toolbar's file menu
                                        to request access. Downloading is not possible.
                                    </li>

                                    </ul>
                                </div>

                                {/*<div className={styles.card}>*/}
                                {/*    <img src={UploadFile} alt="team" className={styles.image}/>*/}
                                {/*</div>*/}
                            </Stack>
                        </div>
                    </CardContent>
                </Card>
                <br></br>

                {/*Request a scan      */}
                <Card>

                    <CardContent className={styles.card}>

                        <div className={styles.margins}>

                            <h2 id="c">Request a scan</h2>-- ARE THESE STILL THE MESSAGES?
                            <hr></hr>
                            <Stack
                                direction="row"
                                spacing={2}
                            >
                                <div>
                                    <p>If the document's thumbnail fails to appear, you will encounter one of the
                                        following messages:
                                    </p>
                                    <ul>
                                    <li className={styles.a}>
                                        "This item has not been scanned. Please request a scan through the items ."
                                        For further inquiries, please reach out to us via eTIC Web Chat, email:
                                        etic@nps.gov, or phone: 303-969-2130. Note: If you have a large number of
                                        uploads, please contact the TIC staff before proceeding with the upload.
                                    </li>

                                    <li className={styles.a}> "This item has been scanned but does not appear in the
                                        thumbnail view. However, you can still view or download the item."
                                    </li>
                                    </ul>
                                </div>

                                {/*<div className={styles.card}>*/}
                                {/*    <img src={UploadFile} alt="team" className={styles.image}/>*/}
                                {/*</div>*/}
                            </Stack>
                        </div>
                    </CardContent>
                </Card>
                <br></br>

                {/*Search for Files*/}
                <Card>
                    <CardContent className={styles.card}>
                        <div className={styles.margins}>
                            <h2 id="d">Search for Files</h2>
                            <hr></hr>
                            <Stack
                                direction="row"
                                spacing={2}
                            >
                                <div>
                                    <p>To initiate a Keyword Search, input your search criteria in the primary search
                                        field located at the top of the page. A dropdown menu may appear to help
                                        identify the appropriate collection. <br></br><br></br>
                                        Note: Do not use Boolean searches.
                                        <br></br>

                                        <br></br>
                                        For instructions on shipping physical copies of your documents, please refer to
                                        the <Link to={"./../workingwithtic"}>Working with TIC </Link> section.
                                    </p>
                                    <br></br>

                                    <h3>Filtering</h3>
                                    <hr></hr>
                                    <p>
                                        You can utilize the Search Filters feature to enhance and narrow down your
                                        search. By selecting limiters such as <b>Park Name, Information Ty pe, Document
                                        Title, Security Type, Location, and/or Date Range</b>, you can refine your results.
                                        Each limiter provides a dropdown menu to facilitate your selection. You can
                                        either manually type in your choice or use the triangle buttons to expand or
                                        collapse the dropdown.
                                        Please note that the Park Names field will only display options with associated
                                        materials. If you prefer not to limit your search results, you can leave the
                                        fields with their default values.

                                    </p>

                                    <br></br>
                                    {/*<h3>Buttons</h3>*/}
                                    {/*<hr></hr>*/}
                                    {/*<p>*/}
                                    {/*    You can utilize the Clear All button to remove all your search criteria,*/}
                                    {/*    including any entries in the Keyword Search field. To initiate the search*/}
                                    {/*    process, simply click on the Search button.*/}
                                    {/*</p>*/}
                                    <br></br>
                                    <h3>Results- MAYBE WE ADD MORE DIRECTIONS ON THE NEW TABLE FILTER?</h3>
                                    <hr></hr>
                                    <p>The search terms used to define your collection in the Keyword Search and Search
                                        Filter will be shown in the Filter Applied section. If the combined search
                                        filters do not contain any shared documents, you will see the message "No
                                        results to display."
                                        <br></br>  <br></br>
                                        The search results will be presented in the Result's Grid. Please note that you
                                        can customize the grid by moving the column headings to sort columns or
                                        adjusting the column width using the column divider. Additionally, you can
                                        change the sorting order from ascending to descending by clicking on the
                                        column's heading.
                                        <br></br>  <br></br>
                                        You have the option to export the search results: either to Excel from the
                                        search Result Grid or in CSV format from the search Result Grid.
                                    </p>
                                    <br></br>
                                    <h3>Record Details--WE DON'T HAVE A "CLEAR" BUTTON ANYMORE, RIGHT?</h3>
                                    <hr></hr>
                                    <p>You can utilize the Clear All button to remove all your search criteria,
                                        including any entries in the Keyword Search field. To initiate the search
                                        process, simply click on the Search button.
                                    </p>


                                </div>

                                <div className={styles.card}>
                                    <img src={Search} alt="team" className={styles.image}/>
                                    <br></br>  <br></br>      <br></br>  <br></br>      <br></br>  <br></br>      <br></br>  <br></br>
                                                              <img src={SearchFilter} alt="Search Filters" className={styles.image2}/>

                                    <img src={Grid} alt="team" className={styles.image3}/>
                                    <br></br>  <br></br>      <br></br>  <br></br>      <br></br>  <br></br>      <br></br>  <br></br>

                                    {/*<img src={UploadFile} alt="team" className={styles.image4}/>*/}

                                </div>
                            </Stack>
                        </div>
                    </CardContent>
                </Card>

                <br></br>
                {/*Share Materials*/}
                <Card>

                    <CardContent className={styles.card}>

                        <div className={styles.margins}>

                            <h2 id="e">Share Materials--IS THIS BUILT? REMOVE?</h2>
                            <hr></hr>
                            <Stack
                                direction="row"
                                spacing={2}
                            >
                                <div>
                                    <p>Easily share your search results with friends and colleagues using our copy URL
                                        feature. Rest assured, we prioritize your privacy by not adding cookies or
                                        visitor tracking information.
                                        <br></br> <br></br>Please be aware that the URL Sharing feature allows you to
                                        share specific metadata search results and attachments. However, due to the
                                        search grid and tabs' customization features, sharing the browser URL is not
                                        stable for the recipient to view the desired metadata pages or attachments.
                                        <br></br> <br></br> To ensure your desired results are shared accurately, use
                                        the "Copy URL" widget found within the 'Record Details' of the item you want to
                                        share.
                                        <br></br> <br></br> If you have a large number of uploads, we recommend reaching
                                        out to our tic staff before uploading.

                                    </p>

                                </div>

                                {/*<div className={styles.card}>*/}
                                {/*    <img src={UploadFile} alt="team" className={styles.image}/>*/}
                                {/*</div>*/}
                            </Stack>
                        </div>
                    </CardContent>
                </Card>

                <br></br>


                {/*/!*Shopping Cart*!/*/}
                {/*<Card>*/}
                {/*    <CardContent className={styles.card}>*/}

                {/*        <div className={styles.margins}>*/}

                {/*            <h2 id="f"> Shopping Cart--NEEDS REWORK</h2>*/}
                {/*            <hr></hr>*/}
                {/*            <Stack*/}
                {/*                direction="row"*/}
                {/*                spacing={2}*/}
                {/*            >*/}
                {/*                <div>*/}
                {/*                    <p>*/}
                {/*                        To add documents to your Shopping Cart, follow these simple steps:*/}
                {/*                    </p>*/}
                {/*                    <ol>*/}
                {/*                        <li> Once you've made your selection(s), use the 'Add to*/}
                {/*                            Cart' button at the top of the grid to confirm your choice(s).*/}
                {/*                        </li>*/}
                {/*                        <br></br>*/}
                {/*                        <li>If you want to add a record to your Shopping Cart*/}
                {/*                            directly from the metadata information (Record Details), click on the*/}
                {/*                            shopping cart icon located in the upper right corner of the page.*/}
                {/*                        </li>*/}
                {/*                        <br></br>*/}
                {/*                        <li> If you want to add a record to your Shopping Cart*/}
                {/*                            directly from the metadata information (Record Details), click on the*/}
                {/*                            shopping cart icon located in the upper right corner of the page.*/}
                {/*                        </li>*/}

                {/*                    </ol>*/}
                {/*                </div>*/}

                {/*                /!*<div className={styles.card}>*!/*/}
                {/*                /!*    <img src={UploadFile} alt="team" className={styles.image}/>*!/*/}
                {/*                /!*</div>*!/*/}
                {/*            </Stack>*/}
                {/*        </div>*/}
                {/*    </CardContent>*/}

                {/*</Card>*/}
                {/*<br></br>*/}


                {/*Teams chat*/}
                <Card>
                    <CardContent className={styles.card}>

                        <div className={styles.margins}>

                            <h2 id="g"> Teams Chat</h2>
                            <hr></hr>
                            <Stack
                                direction="row"
                                spacing={2}
                            >
                                <div>
                                    <p>To get in touch with the TIC staff through the Microsoft Teams environment,
                                        please follow the instructions on the eTIC Chat webpage.
                                        <br></br>
                                      To join the eTIC Web Chat Team, simply enter the code <b>cxxv90a</b>.
                                    </p>
                                </div>

                                <div className={styles.card}>
                                    <img src={Addteam} alt="team" className={styles.imageteam}/>
                                </div>
                            </Stack>
                        </div>
                    </CardContent>

                </Card>
                <br></br>

                {/*View and download*/}
                <Card>
                    <CardContent className={styles.card}>

                        <div className={styles.margins}>

                            <h2 id="h">View and Download</h2>
                            <hr></hr>
                            <Stack
                                direction="row"
                                spacing={2}
                            >
                                <div>
                                    <p>To access a document, click on the displayed thumbnail on the Record Details | Documents in Set page. For drawings with more than 5 pages, click the button below the thumbnail to combine the complete set.
                                        <br></br> <br></br>
                                        The documents will open in a new browser window. You can choose to view them directly within the browser or download them to your computer for viewing later.

                                    </p>
                                </div>

                                <div className={styles.card}>
                                    <img src={UploadFile} alt="team" className={styles.image}/>
                                </div>
                            </Stack>
                        </div>
                    </CardContent>

                </Card>
                <br></br>

            </div>

            <br></br><br></br>
        </div>
    );
}
